import { useEffect, useState } from "react"
import { authRequest } from "src/engine/modules/authRequest"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"

// Спека https://next.stoplight.io/infotech-group/planner/version%2F1.0/main.oas2.yml?view=/plantype/getplantypeavailableeventtypes

export const useAvailableList = ({
  params,
  trigger,
  extraTrigger,
  hold,
  refresh,
}) => {
  const { url, body } = params
  const [listData, setListData] = useState({ data: [], pending: false })
  useEffect(() => {
    if (hold) {
      setListData({ ...listData, pending: true })
      authRequest({
        url,
        params: body,
      })
        .then(response =>
          setListData({ data: get(response, `data`, []), pending: false }),
        )
        .catch(error => {
          showToast({
            type: `error`,
            message: `${error.message}`,
            hideIn: 5,
          })
        })
    }
  }, [refresh, trigger, extraTrigger])

  return listData
}
